import { makeAutoObservable } from "mobx";

import {
  apiPostQuestionnaires,
  CreateFilledQuestionnaireSchema,
  Questionnaire,
} from "../../../api";
import { getServerNowISO } from "../../../utils/server-time";
import { assert } from "../../../utils/utils";

export class QuestionnaireModel {
  responses = new Map<string, QuestionResponse>();
  comment = "";
  fillingEnd = getServerNowISO();

  constructor(
    readonly questionnaire: Questionnaire,
    private patientId: number,
    private userUuid: string,
  ) {
    for (const q of questionnaire.questions) {
      this.responses.set(q.question_id, { response: undefined });
    }
    makeAutoObservable(this);
  }

  async submit() {
    const body: CreateFilledQuestionnaireSchema = {
      questionnaire_id: this.questionnaire.questionnaire_id,
      responses: [],
      patient_id: this.patientId,
      filling_end: this.fillingEnd,
      questionnaire_language: this.questionnaire.language,
      questionnaire_version: this.questionnaire.version,
      user_uuid: this.userUuid,
      comment: this.comment,
    };

    for (const [id, questionResponse] of this.responses.entries()) {
      if (questionResponse.response === undefined) {
        continue;
      }

      const question = this.questionnaire.questions.find(
        (q) => q.question_id === id,
      );
      assert(question, `Question not found: ${id}`);
      const type = question.question_type;

      if (type === "polytomous_single_choice" || type === "dichotomous") {
        body.responses.push({
          question_id: id,
          question_type: type as any,
          question_response: questionResponse.response as string,
        });
      } else if (type === "ordinal") {
        body.responses.push({
          question_id: id,
          question_type: type as any,
          question_response: parseInt(questionResponse.response as string),
        });
      } else if (type === "polytomous_multi_choice") {
        body.responses.push({
          question_id: id,
          question_type: type,
          question_responses: questionResponse.response as string[],
        });
      } else if (type === "continuous") {
        body.responses.push({
          question_id: id,
          question_type: type,
          question_response: questionResponse.response as number,
        });
      }
    }

    await apiPostQuestionnaires({ body });
  }
}

export interface QuestionResponse {
  response: unknown;
}
